import styled, { css } from 'styled-components';
import { ColorsVariables } from '../../../../../assets/styles/colors';
import { SCREEN, SPACE } from '../../../../../assets/styles/constants';
import { flex } from '../../../../../assets/styles/flex-grid';

export const MobileHeaderHeight = '43px';
export const DesktopHeaderHeight = '65px';
export const Header = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	width: 100%;
	z-index: 12;
	height: ${DesktopHeaderHeight};
	display: flex;
	box-shadow: 0px 10px 5px rgba(0, 0, 0, 0.07);
	background-color: white;
	color: ${ColorsVariables.MainGreen};
	${SCREEN.SMALL} {
		height: ${MobileHeaderHeight};
	}
`;
export const HeaderFlex = styled.div`
	${flex};
	font-size: 16px;
	white-space: nowrap;
	
	&:hover {
		cursor: pointer;
		background-image: linear-gradient(180deg,#353944 80%,#353944 0);
	    background-repeat: repeat-x;
	    background-size: 1px 1px;
	    background-position: 0 98%;
	}

	> * {
		cursor: pointer;
	}
`;
export const MobileTableHeader = styled.div`
	display: none;
	${SCREEN.SMALL} {
		margin: 43px 10px 0 10px;
		padding-top: 7px;
		height: 44px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		${props => props.endOfTheGame && 'display: none'};
	}
`;
export const RightHeaderGroup = styled.div`
	${flex};
`;
export const Tab = styled.div`
	${flex};
	height: 100%;
	min-width: 40px;
	border-radius: 3px;
	padding: 10px;
`;
export const TabFlex = styled.div`
	height: 100%;
	${flex};
	font-size: 16px;
	font-weight: bold;
	.my-tab {
		margin-right: 10px;
		color: rgba(31, 165, 154, 0.3);
		border: 1px solid rgba(31, 165, 154, 0.3);
		${props => props.isActive &&
			css`
				color: rgba(31, 165, 154, 1);
				border: 1px solid rgba(31, 165, 154);
			`};
	}
	.opponent-tab {
		color: rgba(239, 26, 0, 0.3);
		border: 1px solid rgba(239, 26, 0, 0.3);
		${props => !props.isActive &&
			css`
				color: rgba(239, 26, 0, 1);
				border: 1px solid rgba(239, 26, 0, 1);
			`};
	}
`;
export const ToolTipCloseIcon = styled.span`
	color: ${ColorsVariables.MainGreen};
	align-self: flex-end;
	cursor: pointer;
`;
